<template>
  <DragPanel
    title="批注"
    :closePanel="closePanel"
    :tooltipVisible="false">
    <div
      class="action-btn-box"
      v-if="isChecked('Project.Single.SceneAnnotation.Operate')">
      <el-button
        type="primary"
        class="primary-btn primary-ang-btn"
        size="small"
        icon="el-icon-plus"
        @click="openAnnotationToolBar">
        新建批注
      </el-button>
    </div>
    <div
      class="annotation-filter-box"
      v-if="originAnnotationList.length">
      <div class="label-box">批注类型：</div>
      <el-select
        class="primary-select"
        size="small"
        v-model="annotationTypeId"
        clearable
        :popper-append-to-body="false"
        @focus="initAnnotationTypeList()"
        @change="updateAnnotationList">
        <el-option
          v-for="(item, index) in annotationTypeList"
          :key="index"
          :label="item.typeName"
          :value="item.typeValue">
          <div
            class="text-overflow"
            :title="item.typeName">
            {{ item.typeName }}
          </div>
        </el-option>
      </el-select>
    </div>
    <AnnotationList
      :annotationList="filterAnnotationList"
      @openAnnotationDialog="openAddAnnotationDialog"
      @openViewportImg="openViewportImg"
      @closeViewportImg="closeViewportImg"
      @openAnnotationViewport="openAnnotationViewport"
      @openAnnotationDetailsPanel="openAnnotationDetailsPanel"
      :refreshAnnotationList="refreshAnnotationList" />
    <AnnotationDetailsPanel
      v-if="isAnnotationDetailsPanelVisible"
      :annotationDetails="annotationDetails"
      @closeAnnotationDetailsPanel="closeAnnotationDetailsPanel" />
    <div
      class="viewport-img-box"
      key="viewportImg"
      v-if="isViewportImgVisible">
      <img :src="viewportImg" />
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import AnnotationList from './AnnotationList.vue'
import AnnotationDetailsPanel from './AnnotationDetailsPanel.vue'

import { Store } from '@/utils/store'

import {
  getSceneAnnotationListService,
  getAnnotationTypeListService
} from '@/service/interface.js'

export default {
  data() {
    return {
      originAnnotationList: [],
      filterAnnotationList: [],
      annotationTypeList: [],
      annotationTypeId: '',

      isViewportImgVisible: '',
      viewportImg: '',

      isAnnotationDetailsPanelVisible: false,
      annotationDetails: {}
    }
  },
  components: {
    DragPanel,
    AnnotationList,
    AnnotationDetailsPanel
  },
  mounted() {
    if (this.isChecked('Project.Single.SceneAnnotation.View')) {
      this.initData()
    }
  },
  methods: {
    async initData() {
      this.annotationTypeList = await this.queryAnnotationTypeList()
      this.queryAnnotationList().then(annotationList => {
        this.originAnnotationList = annotationList
        this.filterAnnotationList = annotationList
      })
    },
    async initAnnotationTypeList() {
      this.annotationTypeList = await this.queryAnnotationTypeList()
    },
    openAnnotationToolBar() {
      this.$emit('openAnnotationToolBar')
    },
    closePanel() {
      this.$emit('closeAnnotationPanel')
    },
    openAddAnnotationDialog(annotationInfo) {
      this.$emit('openAnnotationDialog', annotationInfo)
    },
    openAnnotationDetailsPanel(annotationDetails) {
      this.annotationDetails = annotationDetails
      this.isAnnotationDetailsPanelVisible = true
    },
    closeAnnotationDetailsPanel() {
      this.annotationDetails = {}
      this.isAnnotationDetailsPanelVisible = false
    },
    openViewportImg(viewportImg) {
      if (this.isAnnotationDetailsPanelVisible) return

      this.viewportImg = viewportImg
      this.isViewportImgVisible = true
    },
    closeViewportImg() {
      this.isViewportImgVisible = false
      this.viewportImg = ''
    },
    openAnnotationViewport(viewportImg) {
      this.$emit('openAnnotationViewport', viewportImg)
    },
    refreshAnnotationList() {
      return new Promise(resolve => {
        this.annotationTypeId = ''
        this.queryAnnotationList().then(annotationList => {
          this.originAnnotationList = annotationList
          this.filterAnnotationList = annotationList
          resolve()
        })
      })
    },
    updateAnnotationList(value) {
      if (value) {
        let filterAnnotationList = this.originAnnotationList.filter(
          item => item.annotationTypeId === value
        )
        this.filterAnnotationList = filterAnnotationList
      } else {
        this.filterAnnotationList = this.originAnnotationList
      }
    },
    queryAnnotationList() {
      return new Promise(resolve => {
        let sceneId = this.$route.query.sceneId
        if (!sceneId) {
          resolve([])
          return
        }
        getSceneAnnotationListService(sceneId).then(response => {
          if (response.isSuccess) {
            let annotationList = response.data
            resolve(annotationList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    async queryAnnotationTypeList() {
      let projectZoneId = this.$route.params.projId
      let response = await getAnnotationTypeListService({ projectZoneId })
      if (response.isSuccess) {
        let data = response.data
        let annotationTypeList = data.map(item => {
          item.typeName = item.name
          item.typeValue = item.annotationTypeId
          return item
        })
        return annotationTypeList
      } else {
        this.$message.error(response.errMsg)
      }
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  top: 214px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);

  :deep(.content) {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);
    padding: 8px 20px 16px 16px;

    .action-btn-box {
      display: grid;
      grid-template-columns: 1fr;

      .el-button {
        span {
          display: inline;
        }
      }
    }

    .annotation-filter-box {
      display: flex;
      align-items: center;
      margin-top: 8px;
      font-size: 14px;

      .label-box {
        flex-shrink: 0;
      }

      .primary-select {
        flex-grow: 1;

        .el-select-dropdown {
          width: 100%;
        }
      }
    }

    .viewport-img-box {
      position: absolute;
      left: -50%;
      transform: translate(-50%, 50%);
      margin-left: -30px;
      width: 400px;
      height: 225px;
      background-size: cover;
      background-position: center;
      z-index: 3;
      box-shadow: var(--base-bg-dark-color30);
      border-radius: 8px;
      border: 4px solid var(--base-border-dark-color21);
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
      }
    }
  }
}
</style>
